export const useDefaultData = ({Helpers}) => {

    const {getCurrentDate} = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormTransaction = {
        idmovimiento: '',
        idpago: '',
        idcaja: '',
        idbanco: '',
        movimiento_fecha: getCurrentDate(),
        movimiento_usuario: '',
        movimiento_tipo: '',
        movimiento_monto: '',
        movimiento_moneda: '',
        movimiento_tipo_cambio: '7.8',
        movimiento_quetzales: '',
        movimiento_dolares: '',
        movimiento_observaciones: '',
        boleta_numero: '',
        boleta_foto_originalname: '',
        boleta_foto_filename: '',
        boleta_foto_path: '',

        // Info aprobacion (solo lectura)
        aprobacion_check: '',
        aprobacion_fecha: '',
        aprobacion_referencia_ach: '',
        aprobacion_observaciones: '',
        files: [],
        fileRejections: [],
        acceptedFiles: [],
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormTransaction
    })
}